import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";

export const getQuoteTemplates = () => {
  return queryOptions({
    queryKey: ["/api/quote-templates"],
    queryFn: async () => {
      return await handleClientMethod(client.GET("/api/quote-templates"));
    },
  });
};
